var map = {
	"./da-DK.json": 166,
	"./de-DE.json": 167,
	"./en-US.json": 90,
	"./es-ES.json": 168,
	"./fi-FI.json": 169,
	"./fr-FR.json": 170,
	"./id-ID.json": 171,
	"./it-IT.json": 172,
	"./ja-JP.json": 173,
	"./ko-KR.json": 174,
	"./pt-BR.json": 175,
	"./ro-RO.json": 176,
	"./ru-RU.json": 177,
	"./tr-TR.json": 178,
	"./vi-VN.json": 179,
	"./zh-CN.json": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;